import { Dispatch, SetStateAction, useContext, useRef } from 'react'
import { Icon } from 'assets/index'
import { UserContext } from 'context/userContext'
import {
  Modal,
  Background,
  ChildrenContainer,
  ContentContainer,
  PathContainer,
} from './style'

interface IModal {
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
  children: any
  // buttonDisabled?: boolean
  map?: string
  backButton?: boolean
  onBackButton?: any
  height?: string
  width?: string
  noCloseButton?: boolean
  padding?: string
  onBack?: () => void
}

export default function NewModal(props: IModal) {
  const { setClientOption, setExtended, page, setPage } =
    useContext(UserContext)
  const {
    showModal,
    children,
    setShowModal,
    backButton,
    noCloseButton,
    padding,
    onBack,
  } = props
  const backgroundRef = useRef<HTMLDivElement>(null)

  function closeModal(): void {
    setClientOption('')
    setPage(0)
    setShowModal(false)
    setExtended(false)
  }

  const clickBack = () => {
    setPage((last) => last - 1)
  }

  return showModal ? (
    <Background ref={backgroundRef}>
      <Modal {...props}>
        <ChildrenContainer newPadding={padding}>
          <PathContainer className="path">
            <span className="path">
              {(backButton && page > 0) || (backButton && onBack) ? (
                <img
                  id="button-back-modal"
                  onClick={onBack || clickBack}
                  src={Icon('chevron_left.svg')}
                  alt="back modal"
                  className="close-modal"
                />
              ) : (
                ''
              )}
              {children[page][1]}
            </span>
            <img
              onClick={() => closeModal()}
              src={Icon('x.svg')}
              alt="close modal"
              className="close-modal"
            />
          </PathContainer>
          <ContentContainer>{children[page][0]}</ContentContainer>
        </ChildrenContainer>
      </Modal>
    </Background>
  ) : null
}
